// extracted by mini-css-extract-plugin
export default {"wrapper":"FeedbackCard_wrapper__J8cZi","wrapper__feedback":"FeedbackCard_wrapper__feedback__OHEyC"};